import { useMemo, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { AdfsSetting } from '../../interfaces';
import { Paper, Stack } from '@mui/material';
import { GET_ADFS } from './ADFSConfig.graphql';
import Fuse from 'fuse.js';
import { SearchField } from '../../components/SearchField';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid-pro/locales';
import { Link } from 'react-router-dom';

export default function ADFSList() {
  const { data } = useQuery<{ adfs: AdfsSetting[] }>(GET_ADFS);
  let [searchTerm, setSearchTerm] = useState('');

  const orderedProviders = useMemo(() => {
    const items = data?.adfs ? [...data.adfs] : [];
    items.sort((a, b) => (a.scheme ?? '').toLowerCase().localeCompare((b.scheme ?? '').toLowerCase()));
    return items;
  }, [data]);

  const filterResult = (providers: AdfsSetting[]) => {
    var options = {
      shouldSort: false,
      tokenize: true,
      matchAllTokens: true,
      threshold: 0,
      location: 0,
      distance: 10,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: ['scheme'],
    };
    if (!searchTerm) {
      return providers;
    } else {
      var fuse = new Fuse(providers, options);
      var filtered = fuse.search(searchTerm).map((r: any) => r.item);
      return filtered;
    }
  };

  const filteredResult: AdfsSetting[] = filterResult(orderedProviders);

  const columns = useMemo<GridColDef<AdfsSetting>[]>(
    () => [
      {
        field: 'scheme',
        headerName: 'Provider',
        minWidth: 260,
        flex: 1,
        renderCell: (params) => (
          <Link to={'/license/' + params.row.bksID} style={{ textDecoration: 'none' }}>
            {params.row.scheme}
          </Link>
        ),
      },
      {
        field: 'extraUserPercentage',
        headerName: 'Ekstra tillgang(%)',
        minWidth: 180,
        flex: 0.8,
        renderCell: (params) => (
          <Link to={'/adfssubsetting/' + params.row.bksID} style={{ textDecoration: 'none' }}>
            {params.row.extraUserPercentage}
          </Link>
        ),
      },
    ],
    [],
  );

  return (
    <Stack spacing={2}>
      <Paper elevation={1} sx={{ p: 2 }}>
        <SearchField filter={setSearchTerm} />
      </Paper>

      <DataGridPro
        autoHeight
        density="compact"
        rows={filteredResult}
        columns={columns}
        getRowId={(row) => row.id}
        localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
        pagination
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
              page: 0,
            },
          },
        }}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 700,
          },
        }}
      />
    </Stack>
  );
}
